import { render, staticRenderFns } from "./RadioElement.vue?vue&type=template&id=55e5e004&"
import script from "./RadioElement.vue?vue&type=script&lang=js&"
export * from "./RadioElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports